import { UPDATE_LVZ_MARKER_DATA } from "./lvzMarkerDataReducer"

export const updateLvzMarkerData = (info) => async (dispatch) => {
    dispatch({
        type: UPDATE_LVZ_MARKER_DATA,
        payload: info
    })
}